export type EmailTypeOption = {
    value: number;
    label: string;
};

export const EMAIL_TYPE_OPTIONS: EmailTypeOption[] = [
    { value: 0, label: "InvoiceInpectorForSelf" },
    { value: 1, label: "InvoiceInpectorForAdmin" },
    { value: 2, label: "InvoiceShipOwner" },
    { value: 3, label: "PaymentInspector" },
    { value: 4, label: "PaymentShipOwner" },
    { value: 5, label: "RegisterUser" },
    { value: 6, label: "ResetPassword" },
    { value: 7, label: "ExternalRegister" },
    { value: 8, label: "RegisterInspectionCompanySelf" },
    { value: 9, label: "RegisterInspectionCompanyAdmin" },
    { value: 10, label: "RegisterShipOperatorSelf" },
    { value: 11, label: "RegisterShipOperatorAdmin" },
    { value: 12, label: "RegisterVesselSelf" },
    { value: 13, label: "RegisterVesselAdmin" },
    { value: 14, label: "RegisterCompanyApproved" },
    { value: 15, label: "RegisterCompanyRejected" },
    { value: 16, label: "RegisterVesselApproved" },
    { value: 17, label: "RegisterVesselRejected" },
    { value: 18, label: "CreateSireReview" },
    { value: 19, label: "SireReviewAdmin" },
    { value: 20, label: "SireReviewResultAdmin" },
    { value: 21, label: "SireReviewResultRequestor" },
    { value: 22, label: "NominationInspectingCompany" },
    { value: 23, label: "NominationShipOperator" },
    { value: 24, label: "NominationShipOperatorApproved" },
    { value: 25, label: "NominationShipOperatorRejected" },
    { value: 26, label: "NominationInspectingCompanyApproved" },
    { value: 27, label: "NominationInspectingCompanyRejected" },
    { value: 28, label: "NominationProcessCompleted" },
    { value: 29, label: "NominationCancel" },
    { value: 30, label: "RegisterVesselByAdmin" },
    { value: 31, label: "InvoiceSireReview" },
    { value: 32, label: "InvoiceSireReviewAdmin" },
    { value: 33, label: "InvoiceRequestor" },
    { value: 34, label: "PaymentRequestor" },
    { value: 35, label: "PaymentSireReviewInvoice" },
    { value: 36, label: "NominationShipOperator3rd" },
    { value: 37, label: "InspectorInvoiceApproved" },
    { value: 38, label: "InspectorInvoiceRejected" },
    { value: 39, label: "ShipOperatorPaymentApproved" },
    { value: 40, label: "ShipOperatorPaymentRejected" },
    { value: 41, label: "ConfirmPaymentInspector" },
    { value: 42, label: "InvoiceSireReviewApproved" },
    { value: 43, label: "InvoiceSireReviewRejected" },
    { value: 44, label: "PaymentSireReviewInvoiceConfirmation" },
    { value: 45, label: "PaymentRequestorApproved" },
    { value: 46, label: "RegisterUserShipOperator" },
    { value: 47, label: "NominationInspectorNameChange" },
    { value: 48, label: "ReminderPaymentOperator" },
    { value: 49, label: "ReminderNominationOperator" },
    { value: 50, label: "RerequestSireReview" },
    { value: 51, label: "ReassignSireReview" },
    { value: 52, label: "RejectSireReview" },
];

export const EMAIL_TYPE_MAP: { [key: number]: string } = EMAIL_TYPE_OPTIONS.reduce((map, option) => {
    map[option.value] = option.label;
    return map;
}, {} as { [key: number]: string });

export const getEmailTypeLabel = (emailType: number | string): string => {
    const typeNum = typeof emailType === 'string' ? parseInt(emailType) : emailType;
    return EMAIL_TYPE_MAP[typeNum] || emailType?.toString() || '-';
};
